<template>
  <a-card :bordered="false">
    <div>
      <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
        <div></div>
        <a-button type="primary" @click="addQuestion">
          {{ $t('ADD') || '添加' }}
        </a-button>
      </div>
      <a-row :gutter="16">
        <a-table
          :scroll="{ y: 'calc(100vh - 410px)' }"
          row-key="id"
          :data-source="table.data"
          style="width: 100%">
          <a-table-column
            data-index="title"
            :title="$t('title')"
          >
          </a-table-column>
          <a-table-column
            data-index="date"
            :title="$t('OPERATION')||'操作'">
            <template slot-scope="text, record">
              <a-button
                type="link"
                @click="editQuestion(record.id)">{{ $t('EDIT') || '编辑' }}
              </a-button>
              <a-divider type="vertical"/>
              <a-button
                type="link"
                @click="deleteQuestion(record.id)">{{ $t('DELETE') || '删除' }}
              </a-button>
            </template>
          </a-table-column>
        </a-table>
      </a-row>
    </div>
    <a-modal
      :footer="null"
             :title="$t('EDIT')||'编辑'"
             v-model="form.visible">
      <question-edit
        v-if="form.visible"
        :question-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </question-edit>
    </a-modal>
  </a-card>
</template>

<script>
import {
  _queryQuestions,
  _deleteQuestion,
  _upQuestion,
  _downQuestion,
} from '@/api/questionApi';
import QuestionEdit from './QuestionEdit.vue';

async function getQuestionList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryQuestions({
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content.map(x => ({
    ...x,
    coverPath: x.images ? x.images.split(',') : '',
  }));
}

function addQuestion() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editQuestion(questionId) {
  this.form.data.id = questionId;
  this.form.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.jumpForm.data.id = null;
  this.jumpForm.visible = false;
  this.getQuestionList();
}

async function deleteQuestion(questionId) {
  this.$confirm({
    title: this.$t('CONFIRM_REMOVE'),
    content: '',
    onOk: async () => {
      await _deleteQuestion(questionId);
      this.$message.success(this.$t('REMOVE_SUCCESS'));
      this.getQuestionList();
    },
  });
}

async function upQuestion(questionId) {
  this.$confirm({
    title: this.$t('CONFIRM_REMOVE'),
    content: '',
    onOk: async () => {
      await _upQuestion(questionId);
      this.$message.success(this.$t('REMOVE_SUCCESS'));
      this.getQuestionList();
    },
  });
}

async function downQuestion(questionId) {
  this.$confirm({
    title: '是否下移？',
    content: '',
    onOk: async () => {
      await _downQuestion(questionId);
      this.$message.success(this.$t('REMOVE_SUCCESS'));
      this.getQuestionList();
    },
  });
}

export default {
  name: 'QuestionList',
  components: {
    QuestionEdit,
  },
  data() {
    return {
      jumpForm: {
        data: {
          id: null,
        },
        visible: false,
      },
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'updateAt',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getQuestionList,
    deleteQuestion,
    editQuestion,
    addQuestion,
    closeForm,
    upQuestion,
    downQuestion,
  },
  created() {
    this.getQuestionList();
  },
};
</script>

<style scoped>
.cover-img {
  border-radius: 2px 2px 0 0;
  height: 300px;
  object-fit: cover;
  object-position: top;
}
</style>
